import type { SVGProps } from 'react';

const SvgClassV = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26673)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37258 0 0 5.37259 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#E4007F'
      />
      <path
        d='M11.9999 17.4001C11.578 17.4001 11.1921 17.162 11.0033 16.7844L6.71761 8.21298C6.44222 7.66261 6.66529 6.99297 7.21566 6.71799C7.7677 6.44302 8.43525 6.66526 8.71065 7.21604L11.9999 13.7945L15.2891 7.21604C15.5645 6.6661 16.2333 6.44344 16.7841 6.71799C17.3344 6.99297 17.5575 7.66261 17.2821 8.21298L12.9964 16.7844C12.8076 17.162 12.4217 17.4001 11.9999 17.4001Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26673'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassV;
